// Central content + assets for the Chateaux landing page.

export const OWNER_NAME = "Chateaux Labs";

export const IMAGES = {
  appHero: "/screenshots/01-dashboard-hero.png",
  appAgents: "/screenshots/10-agents.png",
  heroArchitecture:
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwYXJjaGl0ZWN0dXJlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  stagingBefore: "/staging/before.png",
  stagingScandi:
    "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxzY2FuZGluYXZpYW4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODM5MDAwMzN8MA&ixlib=rb-4.1.0&q=85",
  stagingCoastal:
    "https://images.unsplash.com/photo-1695259496167-c05f25f1d793?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjb2FzdGFsJTIwc3R5bGUlMjBsaXZpbmVzcyUyMHJvb20lMjBvY2VhbiUyMHZpZXd8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  stagingModern:
    "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MDl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODM5MDAwMzN8MA&ixlib=rb-4.1.0&q=85",
  dashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MDl8MHwxfHNlYXJjaHwxfHxkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  listing:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MDl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  landingPage:
    "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MDl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzkwMDAzM3ww&ixlib=rb-4.1.0&q=85",
  testimonial1:
    "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  testimonial2:
    "https://images.unsplash.com/photo-1652471943570-f3590a4e52ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
  testimonial3:
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwaGVhZHNob3R8ZW58MHx8fHwxNzgzOTAwMDMzfDA&ixlib=rb-4.1.0&q=85",
};

export const TRUST_BAR = "RENTCAST DATA · MAPBOX · STRIPE · CLAUDE + GEMINI · ISO-27001-ALIGNED";

export const STAGING_STYLES = [
  { id: "modern", label: "Modern minimalist", image: "/staging/after-modern.png" },
  { id: "scandi", label: "Scandinavian", image: "/staging/after-scandi.png" },
  { id: "coastal", label: "Coastal", image: "/staging/after-coastal.png" },
];

export const CLUSTERS = [
  { id: "A", eyebrow: "Cluster A", title: "Win the pitch", body: "Everything you need to walk in confident and walk out with the signed listing agreement." },
  { id: "B", eyebrow: "Cluster B", title: "Market everywhere", body: "One command, six channels. Meta, Google, IG, SMS, LinkedIn, print — all publishable in under a minute." },
  { id: "C", eyebrow: "Cluster C", title: "Close it", body: "Scored leads, structured pipeline, and full ROI attribution so nothing hot ever goes cold." },
  { id: "D", eyebrow: "Cluster D", title: "The intelligence layer", body: "The AI that remembers, listens, and quietly gets sharper the more you use it." },
];

export const FEATURES = [
  // A · Win the pitch
  { cluster: "A", icon: "Award", title: "Win the listing", line: "Win more listings at the pitch.",
    body: "Generate a private appointment page — AVM, comps, marketing plan, AI talking points." },
  { cluster: "A", icon: "Image", title: "Virtual staging", line: "Sell faster with scroll-stopping photos.",
    body: "Photorealistic AI staging in any style, in ~30 seconds. No stagers, no delays." },
  { cluster: "A", icon: "Camera", title: "Native 360° tour capture", line: "Buyers tour before they ever visit.",
    body: "Guided panorama sweep on your phone — stitched server-side with OpenCV and published to a Pannellum 360° viewer on the listing page. No external hardware." },
  { cluster: "A", icon: "PenLine", title: "Listing Copywriter", line: "Editorial listing prose. In your voice.",
    body: "Feed the AI 3 photos and a few words; it drafts MLS remarks, hero paragraph, and social captions matched to your tone (learned from your persona library)." },

  // B · Market everywhere
  { cluster: "B", icon: "Target", title: "AI Ad Engine", line: "Cut cost-per-lead by up to 60%.",
    body: "$25–$80 per lead vs $65–$180 DIY. Meta + Google campaigns on autopilot; AI copy converts 2–3×." },
  { cluster: "B", icon: "CreditCard", title: "NFC Card + Public Landing", line: "Turn every handshake into a lead.",
    body: "One tap opens your card.chateaux.ai profile — active listings, tours, calendar, AI chat. Every scan drops into your Leads inbox with full attribution." },
  { cluster: "B", icon: "Share2", title: "One-tap Social", line: "Just Listed / Just Sold in 15 seconds.",
    body: "5 platform-perfect captions + an AI hero image, ready to copy or one-tap share to IG, FB, LI, X, TikTok." },

  // C · Close it
  { cluster: "C", icon: "Inbox", title: "Lead Pipeline", line: "Never miss a hot lead again.",
    body: "Every QR scan captures a lead — AI scores it 0–10 the moment they land. HOT, WARM, and NEW pills sort themselves." },
  { cluster: "C", icon: "Kanban", title: "Deal Kanban", line: "Every deal moves. Or you know why.",
    body: "Drag-and-drop lanes — New · Nurturing · Tour Booked · Offer · Won/Lost. AI nudges when a card sits too long." },
  { cluster: "C", icon: "PieChart", title: "Team Dashboard", line: "See ROI for every agent.",
    body: "Broker rollup: cost per lead per agent, ROI per market, seat budgets, unified branding template." },
  { cluster: "C", icon: "Crosshair", title: "Competitor Radar", line: "Out-market every rival agent.",
    body: "AI reads their sites & socials and hands you 5 tactics you can copy today, plus a weekly Compass/RE-MAX/@top-agent digest." },

  // D · The intelligence layer
  { cluster: "D", icon: "BarChart2", title: "Market Intel", line: "Price with confidence, instantly.",
    body: "RentCast AVM + AI neighborhood narrative for any US address. Comps mapped, medianed, and explained." },
  { cluster: "D", icon: "Users", title: "Virtual AI team", line: "A back office that never sleeps.",
    body: "Concierge · Copywriter · Market Analyst · Negotiator · Lead Qualifier — plus custom agents you build. Route any query to the right specialist in one tap." },
  { cluster: "D", icon: "BrainCircuit", title: "AI Persistent Memory", line: "The concierge that actually remembers you.",
    body: "Chateaux quietly builds a memory of your farm area, top brokerages, buyer archetypes, and listing tone — and gets sharper every conversation. Facts decay if stale. Edit or delete anything, anytime." },
  { cluster: "D", icon: "Mic", title: "Voice-to-Concierge", line: "Just talk. Chateaux listens.",
    body: "Push-to-hold the mic while driving between showings — “draft the ad copy for the Round Rock listing”, release, done. Whisper transcription in under 2 seconds." },
  { cluster: "D", icon: "Sunrise", title: "Morning Brief AI", line: "A Bloomberg terminal for your book of business.",
    body: "7 AM every day the concierge digests overnight activity — new leads, listing views, competitor moves, hotness shifts, deals gone cold — and writes you a 60-second brief. Read it with your first coffee." },
];
export const PRODUCT_TABS = {
  solo: {
    id: "solo",
    label: "For Solo Agents",
    sub: "Everything your marketing agency did — for $49/month.",
    bullets: [
      "5-minute setup, no IT approval",
      "Unlimited AI staging + 360° tour capture",
      "1-tap ad campaigns (Meta + Google)",
      "RentCast AVM + neighborhood narratives",
      "Public agent card at card.chateaux.ai",
      "Voice-to-Concierge + persistent memory",
      "Attribution dashboard for every dollar",
      "Deal Kanban + auto lead scoring",
    ],
    shots: [
      "/screenshots/morning-brief-home.png",
      "/screenshots/13-listing-detail.png",
      "/screenshots/18b-public-landing-mobile-full.png",
    ],
  },
  brokerage: {
    id: "brokerage",
    label: "For Brokerages",
    sub: "One dashboard. Every agent. Every dollar accounted for.",
    bullets: [
      "Broker rollup dashboard — cost per lead per agent, ROI per market, seat budget alerts",
      "Two-step agent invite — send a short code or QR; new agent inherits your brand at signup",
      "Unified branding across every agent's card, listing page, and ad — one logo change ripples everywhere",
      "Team persona library — build the AI concierge tone once, share across all seats",
    ],
    shots: [
      "/screenshots/broker-rollup-desktop.png",
      "/screenshots/broker-rollup-mobile.png",
      "/screenshots/08-analytics.png",
    ],
  },
};

export const STEPS = [
  {
    n: "01",
    title: "List it.",
    body: "Add address, price, photos. AI writes the description, stages the room, and builds a public landing page automatically.",
  },
  {
    n: "02",
    title: "Market it.",
    body: "Generate Meta + Google ad creative in seconds. Share the QR on yard signs, socials, and open-house flyers.",
  },
  {
    n: "03",
    title: "Close it.",
    body: "Every scan becomes a scored lead in your inbox. The AI Concierge follows up while you're showing the next home.",
  },
];

export const PLANS = [
  {
    name: "Trial",
    price: "Free",
    cadence: "14 days",
    for: "Try before you buy",
    included: ["1 listing", "5 AI actions / day"],
    popular: false,
  },
  {
    name: "Solo Agent",
    price: "$49",
    cadence: "/mo",
    for: "Independents",
    included: ["Unlimited AI", "1 seat", "All features"],
    popular: false,
  },
  {
    name: "Broker Starter",
    price: "$149",
    cadence: "/mo",
    for: "Boutique brokerages",
    included: ["5 agents", "Team dashboard", "Shared budget"],
    popular: false,
  },
  {
    name: "Broker Pro",
    price: "$299",
    cadence: "/mo",
    for: "Growth teams",
    included: ["15 agents", "Priority AI", "Advanced analytics"],
    popular: true,
  },
  {
    name: "Agency Enterprise",
    price: "$599",
    cadence: "/mo",
    for: "Large agencies",
    included: ["50 agents", "Dedicated support", "Custom integrations"],
    popular: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I listed 4 homes in my first 2 weeks with Chateaux. The staging alone paid for the year.",
    name: "Sarah K.",
    role: "Solo Agent, Austin",
    image: IMAGES.testimonial1,
  },
  {
    quote:
      "We cut our cost per lead by 63% in the first quarter. And every agent finally has consistent branding.",
    name: "Marcus D.",
    role: "Managing Broker, Miami",
    image: IMAGES.testimonial2,
  },
  {
    quote:
      "The 360° capture from my phone is unreal. Buyers show up already sold.",
    name: "Priya S.",
    role: "Team Lead, Toronto",
    image: IMAGES.testimonial3,
  },
];

export const INTEGRATIONS = [
  { name: "Mapbox", icon: "Map" },
  { name: "RentCast", icon: "Home" },
  { name: "Stripe", icon: "CreditCard" },
  { name: "Resend", icon: "Send" },
  { name: "Cloudinary", icon: "Cloud" },
  { name: "Claude Sonnet 4.5", icon: "Sparkles" },
  { name: "Gemini Nano Banana", icon: "Gem" },
  { name: "OpenAI Whisper", icon: "Mic" },
  { name: "Apify", icon: "Crosshair" },
  { name: "Smartlead", icon: "MailPlus" },
  { name: "Pannellum", icon: "Globe" },
];

export const FAQS = [
  {
    q: "Do I need to be tech-savvy?",
    a: "No. If you can send a text, you can run Chateaux. Your first listing goes live in about three minutes.",
  },
  {
    q: "Which countries do you support?",
    a: "The app itself is available worldwide. Authoritative property data (AVM, comps) is US-only via RentCast; other countries fall back to an AI-generated brief that is clearly labeled.",
  },
  {
    q: "Can I bring my own brand / logo?",
    a: "Yes. Brokerage plans include unified branding across all agent landing pages and public cards.",
  },
  {
    q: "What AI models are used?",
    a: "Claude (Anthropic) for copy and analysis. Gemini Nano Banana for image staging + AI restyle. OpenCV for 360° stitching (self-hosted). Cloudinary for hosting stitched panoramas.",
  },
  {
    q: "Is my data used to train AI models?",
    a: "No. Chateaux uses Claude and Gemini via anonymized API calls. Your data is never used for model training. See our Privacy Policy for details.",
  },
  {
    q: "Do you store credit card details?",
    a: "No. All payments are tokenized via Stripe (PCI-DSS Level 1).",
  },
  {
    q: "How do I cancel?",
    a: "From your Account tab, one tap. No calls, no retention flow.",
  },
  {
    q: "Do you support MLS integrations?",
    a: "Direct MLS integrations via CREA-DDF partner agreements. Reach out for board-specific enrollment.",
  },
  {
    q: "Is there a native iOS + Android app?",
    a: "Yes — the app is built with React Native (Expo). Native iOS and Android versions ship from the same codebase, plus a responsive web build so agents can also work from a laptop.",
  },
  {
    q: "What about GDPR & CCPA?",
    a: "Both supported. Users can export or delete their data via /legal/data-deletion.",
  },
];

export const NAV_LINKS = [
  { label: "Features", to: "/features" },
  { label: "NFC Card", to: "/product/nfc-card" },
  { label: "Pricing", to: "/pricing" },
];
